export default class InboundRedemptionFollowUpCapturedDocument {

    constructor(json) {
        if (!json) {
            return;
        }
        this.requirementId = json["requirement-document-id"];
        this.metaDataId = json["meta-data-id"];
        this.documentTypeId = json["document-type-id"];
    }

    static toJson(capturedDocument) {
        let json = {}
        json["requirement-document-id"] = capturedDocument.requirementId
        json["meta-data-id"] = capturedDocument.metaDataId
        json["document-type-id"] = capturedDocument.documentTypeId
        return json;
    }
}